/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Body_login } from '../models/Body_login';
import type { LoginSuccess_Out } from '../models/LoginSuccess_Out';
import type { RefreshToken_In } from '../models/RefreshToken_In';
import type { UserInfo_Out } from '../models/UserInfo_Out';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AuthenticationService {

    /**
     * Login For Access Token
     * User login with email and password
     * @param formData
     * @returns LoginSuccess_Out Successful Response
     * @throws ApiError
     */
    public static login(
        formData: Body_login,
    ): CancelablePromise<LoginSuccess_Out> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/login',
            formData: formData,
            mediaType: 'application/x-www-form-urlencoded',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Refresh For Access Token
     * Refresh the JWT token for the user
     * @param requestBody
     * @returns LoginSuccess_Out Successful Response
     * @throws ApiError
     */
    public static getRefreshToken(
        requestBody: RefreshToken_In,
    ): CancelablePromise<LoginSuccess_Out> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/refresh-token',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Current User Info
     * Get the current user information
     * @returns UserInfo_Out The current user information
     * @throws ApiError
     */
    public static getCurrentUserInfo(): CancelablePromise<UserInfo_Out> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/me',
        });
    }

    /**
     * Unlock User
     * Unlock the user account
     * @param userId The user id to unlock the account for
     * @returns void
     * @throws ApiError
     */
    public static unlockUserAccount(
        userId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/unlock-account/{user_id}',
            path: {
                'user_id': userId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

}